import { Grid, Separator, Table, Text } from "@chakra-ui/react";
import { UI } from "components";
import useCashBalance from "hooks/useCashBalance";
import useCashList from "hooks/useCashList";
import moment from "moment";
import { useState } from "react";

export default function Financial(){

    const balance = useCashBalance()

    const [ page, setPage ] = useState(1)
    const list = useCashList(page)

    const columns = [{ children: 'Descrição' }, { children: 'Valor', textAlign: 'right' }, { children: 'Data', textAlign: 'right' }]

    return(
    <>
    <UI.Header title="Financeiro" />

    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>
        <UI.Box p={4} bg="transparent">
            <Text fontSize="xs" color="fg.muted">Saldo disponível:</Text>
            <Text fontSize="xl" fontWeight="bold" color="green.focusRing"><UI.Number.Amount value={balance.data} /></Text>
        </UI.Box>

    </Grid>

    <Separator my={4} />

    <UI.Table loading={list.isFetching} label="Histórico de movimentações:" columns={columns} data={list.data?.data} meta={list.data?.meta} Row={Row} onPageChange={e => setPage(e.page)} />
    </>
    )
}

const Row = ({ data }) => {
    return(
    <Table.Row>
        <Table.Cell fontSize="xs">{data?.operation === 1 ? '🟢' : '🔴'} {data?.label}</Table.Cell>
        <Table.Cell textAlign="right" fontSize="sm" fontWeight="bold" color={data?.operation === 1 ? 'green.fg' : 'red.fg'}>{data?.operation === 2 ? '- ' : '+ '}<UI.Number.Amount value={data?.amount} /></Table.Cell>
        <Table.Cell textAlign="right" fontSize="xs">{moment(data?.created_at).format('LLL')}</Table.Cell>
    </Table.Row>
    )
}